import t from 'tcomb';
import Natural from './Natural';
import Locale_Iso from './Locale_Iso';
import Language from './Language';
import Country from './Country';
import Datetime from './Datetime';
import formatNumber from '../util/formatNumber';
import Number_Format from './Number_Format';

const Locale = t.struct({
  language: Language,
  country: Country
}, 'Locale');

Locale.of = function(iso) {
 iso = Locale_Iso(iso);
 const [language, country] = iso.split('_');
 return Locale({language, country});
};

Locale.prototype.toJSON = Locale.prototype.toString = function () {
  return this.language + '_' + this.country;
};

// il bundle di localizzazione serve per formattare numeri, date e valute
Locale.prototype.locale_bundle = function (): t.Object {
  return window.require('io/' + this);
};

// il bundle di internazionalizzazione
// Serve per tradurre le regole di validazione di una form, tradurre i paesi
// e le lingue
Locale.prototype.language_bundle = function (): t.Object {
  return window.require('io/' + this.language);
};

Locale.prototype.display_country = function (country: Country): t.String {
  return this.language_bundle().country[country];
};

Locale.prototype.display_language = function (language: Language): t.String {
  return this.language_bundle().language[language];
};

Locale.prototype.to_number_format = function (opt_digits: ?Natural) {
  var bundle = this.locale_bundle().number;
  return new Number_Format({
    decimal_symbol: bundle.decimal_symbol,
    digits: t.Nil.is(opt_digits) ? bundle.digits : opt_digits,
    grouping_symbol: bundle.grouping_symbol,
    infinity: bundle.infinity,
    negative_suffix: bundle.negative_suffix,
    positive_suffix: bundle.positive_suffix
  });
};

Locale.prototype.format_date = function (millis, is_accurate: ?t.Boolean) {
  var bundle = this.locale_bundle().date;
  var pattern = is_accurate ? bundle.accurate : bundle['short'];
  return Datetime.format(millis, pattern);
};

Locale.prototype.format_number = function (n: t.Number, digits: ?Natural) {
  return formatNumber(n, this.to_number_format(digits));
};

Locale.prototype.format_integer = function (n: t.Number) {
  return this.format_number(n, 0);
};

Locale.prototype.parse_number = function (n: t.Number) {
  return this.to_number_format().parse_number(n);
};

Locale.prototype.getTcombFormDateOrder = function () {
  return this.locale_bundle().date.order.map((part) => {
    if (part === 'DD') {
      return 'D';
    }
    if (part === 'MM') {
      return 'M';
    }
    return part;
  });
};

module.exports = Locale;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Locale.js
 **/